import type { StoreState } from '../types/types';
import { initialSessionState } from './schemas';

export function createInitialState(): { settings: StoreState['settings'] } {
  return {
    settings: {
      theme: 'dark',
      units: 'metric',
      fogOfWar: {
        enabled: false,
        data: null,
        eraserSize: 40,
      },
      grids: {},
      showMapRegions: true,
      showMapMarkers: true,
      activeDataViewTab: 'party-roster',
      activeWorldBuildingTab: 'worlds',
      activeMapAssetsTab: 'regions',
      activeMainTab: '/',
      panelSettings: {},
    },
  };
}

export { initialSessionState };